import Home from './Home';

export default Home;



// WEBPACK FOOTER //
// ./src/pages/static/Home/index.jsx